"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reduxForm = require("redux-form");

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _deepObjectDiff = require("deep-object-diff");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(_ref) {
  var _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      _ref$validate = _ref.validate,
      validate = _ref$validate === void 0 ? function () {} : _ref$validate,
      _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues;
  return function (WrappedComponent) {
    var Form =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Form, _React$Component);

      function Form() {
        _classCallCheck(this, Form);

        return _possibleConstructorReturn(this, _getPrototypeOf(Form).apply(this, arguments));
      }

      _createClass(Form, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props = this.props,
              valid = _this$props.valid,
              values = _this$props.values,
              baseValues = _this$props.baseValues;

          if ((0, _isEqual2.default)(prevProps.valid, valid) && (0, _isEqual2.default)(prevProps.values, values)) {
            return;
          }

          if (valid) {
            this.props.onChange((0, _deepObjectDiff.updatedDiff)(baseValues || initialValues, values));
          }
        }
      }, {
        key: "render",
        value: function render() {
          var props = (0, _pick2.default)(this.props, ['fields', 'settings', 'children', 'DataConnectorsPicker']);

          if (this.props.showHighlightedFields) {
            props.highlightedFields = Object.keys((0, _deepObjectDiff.updatedDiff)(this.props.baseValues || initialValues, this.props.values));
          }

          return _react.default.createElement(WrappedComponent, props);
        }
      }]);

      return Form;
    }(_react.default.Component);

    _defineProperty(Form, "propTypes", {
      valid: _propTypes.default.bool,
      values: _propTypes.default.object,
      onChange: _propTypes.default.func,
      baseValues: _propTypes.default.object,
      showHighlightedFields: _propTypes.default.bool
    });

    _defineProperty(Form, "defaultProps", {
      onChange: function onChange() {}
    });

    return (0, _reduxForm.reduxForm)({
      form: 'templateSettingsForm',
      fields: fields,
      validate: validate,
      initialValues: initialValues
    })(Form);
  };
};

exports.default = _default;